import React from "react";
import { Navigate } from "react-router-dom";
import { useUserAuth } from "../context/UserAuthContext";
const ProtectedRoute = ({ children }) => {
  const { user } = useUserAuth();
  if (!user) {
    return <Navigate to="/" />;
  }
  return children;
};

export default ProtectedRoute;





// import React from "react";
// import { Navigate } from "react-router-dom";
// import { useUserAuth } from "../context/UserAuthContext";

// const ProtectedRoute = ({ children, allowedRoles }) => {
//   const { user, userData } = useUserAuth();

//   if (!user) {
//     return <Navigate to="/" />;
//   }

//   // Check if user has required role
//   if (allowedRoles && !allowedRoles.includes(userData?.status)) {
//     return <Navigate to="/home" />; // or to a "not authorized" page
//   }

//   return children;
// };

// export default ProtectedRoute;
